const DEFAULT_PLAN_WIDTH = 1024;
const DEFAULT_PLAN_HEIGHT = 768;
const DEFAULT_PLAN_MIME_TYPE = "image/jpeg";

let whitePlanBlobPromise: Promise<Blob> | null = null;

const createWhitePlanBlob = (): Promise<Blob> => {
  const canvas = document.createElement("canvas");
  canvas.width = DEFAULT_PLAN_WIDTH;
  canvas.height = DEFAULT_PLAN_HEIGHT;

  const context = canvas.getContext("2d");
  if (!context) {
    return Promise.reject(new Error("Failed to create canvas context"));
  }

  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, canvas.width, canvas.height);

  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (blob) resolve(blob);
      else reject(new Error("Failed to create white plan blob"));
    }, DEFAULT_PLAN_MIME_TYPE);
  });
};

const getWhitePlanBlob = (): Promise<Blob> => {
  whitePlanBlobPromise ??= createWhitePlanBlob();
  return whitePlanBlobPromise;
};

const getWhitePlanFile = async (floorId: string): Promise<File> => {
  const blob = await getWhitePlanBlob();
  return new File([blob], floorId, { type: DEFAULT_PLAN_MIME_TYPE });
};

export { DEFAULT_PLAN_HEIGHT, DEFAULT_PLAN_WIDTH, getWhitePlanFile };
